(function () {
  var fw_events = [
    "fw:embed-feed:thumbnail-load",
    "fw:embed-feed:thumbnail-click",
    "fw:embed-feed:impression",
    "fw:storyblock:impression",
    "fw:player:transition",
    "fw:player:quit",
    "fw:video:impression",
    "fw:video:start",
    "fw:video:interactable-engaged-view",
    "fw:video:first-quartile",
    "fw:video:midpoint",
    "fw:video:third-quartile",
    "fw:video:complete",
    "fw:video:session",
    "fw:video:click-cta",
    "fw:video:click-share",
    "fw:video:share",
    "fw:video:submit-answer",
    "fw:video:submit-choice",
    "fw:livestream:join",
    "fw:livestream:quit",
    "fw:livestream:send-chat",
    "fw:livestream:send-heart",
    "fw:shopping:cart-updated",
    "fw:shopping:request-checkout",
    "fw:shopping:product-clicked",
    "fw:shopping:product-card-clicked",
    "fw:shopping:pdp-primary-cta-clicked",
    "fw:shopping:pinned-product-clicked",
    "fw:shopping:clickshoppay",
    "fw:shopping:click-buy",
    "fw:shopping:click-calculate-total",
    "fw:shopping:click-place-order"
  ];

  function sanitize(obj) {
    try {
      return JSON.parse(
        JSON.stringify(obj, function (key, value) {
          // DOM ノードは除外
          if (value instanceof Node) return undefined;
          // 関数は除外
          if (typeof value === "function") return undefined;
          // undefined は JSON.stringify で消えるが一応除外
          if (value === undefined) return undefined;
          return value;
        })
      );
    } catch (e) {
      return {};
    }
  }

  function publish(eventName, detail) {
    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof Shopify.analytics.publish === "function"
    ) {
      try {
        Shopify.analytics.publish(eventName, sanitize(detail));
      } catch (err) {
        console.warn("[FW Publisher] publish failed:", eventName, err);
      }
    }
  }

  fw_events.forEach(function (ev) {
    document.addEventListener(
      ev,
      function (event) {
        publish(ev, event.detail || {});
      },
      { passive: true }
    );
  });
})();
